import React, { useMemo } from "react";
import { MarketFooterProps } from "./types";
import { Grid } from "components/src/components/Grid/Grid";
import { Button } from "components/src/components/Button/Button";
import { EventDetails } from "./components/EventDetails";
import { Icon } from "components/src/components/Icon/Icon";
import { TemplateDetails } from "./components/TemplateDetails";
const _onShowMoreClick = () => {};

export const MarketFooter = ({
  eventDetails,
  hasSGP = false,
  hasFirebets = false,
  hasLivestream = false,
  moreWagers = false,
  showMore = false,
  showLimit,
  filters,
  showMoreTotal,
  canShowLess = true,
  onShowMoreClick = _onShowMoreClick,
  ...rest
}: MarketFooterProps) => {

  const _eventDetails = useMemo(()=>{
    return { ...eventDetails, hasLivestream, hasSGP, noPad: true }
  },[eventDetails, hasLivestream]);
  
  return (
    <Grid {...rest} flush>
      <Grid.Cell colSpan={11}>
        <EventDetails {..._eventDetails} />
      </Grid.Cell>
      <Grid.Cell colSpan={1} items="end" className="cui-items-start">
        <TemplateDetails hasFirebets={hasFirebets} hasSGP={false} moreWagers={false}  />
      </Grid.Cell>
      {showLimit !== "all" && showMore ? (
        <Grid.Cell colSpan="full">
          <div className="cui-flex cui-justify-center cui-text-fg-primary body-md-bold">
            <Button
              text={`Show More ${showMoreTotal && Math.sign(showMoreTotal) !== -1 ? `(${showMoreTotal})` : ""}`}
              type="minimal"
              size="sm"
              rightIcon="ui_chevron-down"
              onClick={onShowMoreClick}
              animation={false}
            />
          </div>
        </Grid.Cell>
      ) : canShowLess && showLimit === "all" ? (
        <Grid.Cell colSpan="full">
          <div className="cui-flex cui-justify-center cui-text-fg-primary body-md-bold">
            <Button
              text={`Show Less`}
              type="minimal"
              size="sm"
              rightIcon="ui_chevron-up"
              onClick={onShowMoreClick}
              animation={false}
            />
          </div>
        </Grid.Cell>
      ) : null}
    </Grid>
  );
};
